module.exports = __webpack_public_path__ + "img/charging-station-white.3cbf35a6.svg";